// original: https://git.hubteam.com/HubSpot/conversations-internal-schema/blob/1729733ab4b5cfdd5950af37c67157f5deb9589b/static/js/team/operators/getNodeAtAddress.js
export const getNodeAtAddress = (keyAddress, tree) => {
  const keyAddressCopy = keyAddress.slice();
  let node = tree.get(`${keyAddressCopy.shift()}`);
  while (keyAddressCopy.length) {
    const key = keyAddressCopy.shift();
    node = node.getIn(['childTeams', `${key}`]);
  }
  return node;
};